import { render, staticRenderFns } from "./DefectViewLoader.vue?vue&type=template&id=ccd0f644&"
import script from "./DefectViewLoader.vue?vue&type=script&lang=js&"
export * from "./DefectViewLoader.vue?vue&type=script&lang=js&"
import style0 from "./DefectViewLoader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports